import { render, staticRenderFns } from "./PayTicket.vue?vue&type=template&id=2165fde6&scoped=true"
import script from "./PayTicket.vue?vue&type=script&lang=js"
export * from "./PayTicket.vue?vue&type=script&lang=js"
import style0 from "./PayTicket.vue?vue&type=style&index=0&id=2165fde6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2165fde6",
  null
  
)

export default component.exports